<script>
    import { onMount } from 'svelte';

    // -- EXPORTS

    /** @type {{value?: boolean, onChange?: any, ariaLabel?: string, isPreviewSwitch?: boolean}} */
    let {
        value = $bindable(false),
        onChange = () => {},
        ariaLabel = 'Switch',
        isPreviewSwitch = false
    } = $props();

    let checked = '';

    // -- FUNCTIONS

    function handleChangeEvent(
        event
        )
    {
        value = event.target.checked;

        onChange( value);
    }

    // -- STATEMENTS

    onMount(() => {
        checked = value;
    });
</script>

<div class="switch" role="switch" aria-checked={ checked.toString() } aria-label="{ ariaLabel }">
    <input
        class="input"
        type="checkbox"
        bind:checked
        onchange={handleChangeEvent}
        aria-hidden="true"
    />
    <span class="slider">
        {#if isPreviewSwitch}
            <div></div>
        {/if}
    </span>
</div>
